import LecomRefluxEvents from 'reflux/events/lecom_reflux_events';

export default Object.assign({}, LecomRefluxEvents, {
	// Process events
	LOAD_PROCESS_INSTANCE_DATA: "LOAD_PROCESS_INSTANCE_DATA",
	LOAD_PROCESS_INSTANCE_DATA_SUCCESS: "LOAD_PROCESS_INSTANCE_DATA_SUCCESS",
	LOAD_PROCESS_INSTANCE_DATA_ERROR: "LOAD_PROCESS_INSTANCE_DATA_ERROR",

	// Render events
	DISPLAY_FORM_RESULT_MESSAGES: "DISPLAY_FORM_RESULT_MESSAGES",

	// Form events
	PROCESS_FORM_DEFINITION_LOAD_ERROR: "PROCESS_FORM_DEFINITION_LOAD_ERROR",
	PROCESS_FORM_INITIAL_VALUES_LOAD_ERROR: "PROCESS_FORM_INITIAL_VALUES_LOAD_ERROR",
	LOAD_SUCCESS_BLOCKED_PROCESS: 'LOAD_SUCCESS_BLOCKED_PROCESS',

	// Submit events
	PROCESS_FORM_SUBMIT_ERROR: "PROCESS_FORM_SUBMIT_ERROR",
	PROCESS_FORM_SUBMIT_SUCCESS: "PROCESS_FORM_SUBMIT_SUCCESS",

	// Validation events
	PROCESS_FORM_VALIDATION_ERROR: "PROCESS_FORM_VALIDATION_ERROR",

	// Actions events
	ACTIVITY_ASSIGN_ACTIVITY_TO_USER: "ACTIVITY_ASSIGN_ACTIVITY_TO_USER",
	ACTIVITY_FORM_MARK_AS_READ: "ACTIVITY_FORM_MARK_AS_READ",
	ACTIVITY_FORM_SAVE: "ACTIVITY_FORM_SAVE",
	ACTIVITY_FORM_SAVE_SUCCESS: "ACTIVITY_FORM_SAVE_SUCCESS",
	ACTIVITY_FORM_SAVE_ERROR: "ACTIVITY_FORM_SAVE_ERROR",

	// Integration events
	BACK_TO_START: "BACK_TO_START",
	MULTIPLE_COMPLETE_ACTIVITY_ACTION_FAILED: "MULTIPLE_COMPLETE_ACTIVITY_ACTION_FAILED",

	LOAD_PROCESS_STORE_PROPS: "LOAD_PROCESS_STORE_PROPS",
	FORM_PROCESS_FINISH: "FORM_PROCESS_FINISH",
	READ_ONLY_TOOLBOX_BUTTONS: "READ_ONLY_TOOLBOX_BUTTONS"
});
